import React from 'react';
import { Reveal } from './Reveal';
import { Section } from './Section';
import styles from './FinalCtaSection.module.css';

interface FinalCtaSectionProps {
  onPrimaryCtaClick: () => void;
}

export function FinalCtaSection({ onPrimaryCtaClick }: FinalCtaSectionProps) {
  return (
    <Section id="zaver" title="First Batch. 200 Kits.">
      <Reveal>
        <div className={styles.wrap}>
          <div className={styles.scarcityRow}>
            <div className={styles.scarcityBar} role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="68% of first batch reserved">
              <div className={styles.scarcityFill} style={{ width: '68%' }} />
            </div>
            <p className={styles.scarcityText}>68% reserved · 64 kits remaining in NYC</p>
          </div>

          <div className={styles.priceBlock}>
            <span className={styles.price}>$49</span>
            <span className={styles.priceDetail}>· Free NYC delivery · No payment now</span>
          </div>

          <p className={styles.text}>
            Leave your email. We'll send you the checkout link before anyone else —
            and you can decide then. No pressure. No card required.
          </p>

          <button type="button" className={styles.button} onClick={onPrimaryCtaClick}>
            Reserve My Spot — $49
          </button>
          <p className={styles.microtext}>No credit card. Unsubscribe any time.</p>
        </div>
      </Reveal>
    </Section>
  );
}
